export default function getRectangle(criterePlanning, eventStart, eventEnd) {
  try {
    if (!eventStart.isValid() ||
      !eventEnd.isValid() ||
      criterePlanning.dateStart > eventEnd ||
      criterePlanning.dateEnd < eventStart) {
      return null;
    }
    let rectStart = eventStart.clone();
    if (rectStart < criterePlanning.dateStart) {
      rectStart = criterePlanning.dateStart.clone();
    }
    let rectEnd = eventEnd.clone();
    if (rectEnd > criterePlanning.dateEnd) {
      rectEnd = criterePlanning.dateEnd.clone();
    }
    const offset = (rectStart.diff(criterePlanning.dateStart, 'days') + 0) / criterePlanning.days * 100;
    const duree = (rectEnd.diff(rectStart, 'days') + 1) / criterePlanning.days * 100;
    const result = {
      x1: offset,
      x2: offset + duree,
      x1WithPadding: offset + 0.25,
      x2WithPadding: offset + duree - 0.25,
      xmilieu: offset + (duree / 2),
      xmilieuWithPadding: offset + 0.25 + ((duree - 0.5) / 2),
      width: duree,
      widthWithPadding: duree - 0.5,
    };
    ['x1', 'x2', 'x1WithPadding', 'x2WithPadding', 'xmilieu', 'xmilieuWithPadding', 'width', 'widthWithPadding'].forEach((key) => {
      result[key + 'String'] = result[key] + '%';
    });
    return result;
  } catch (error) {
    throw error;
  }
}



// WEBPACK FOOTER //
// ./src/services/catalogue/planningHelper.js